export default __webpack_public_path__ + "static/media/avatar_cow7.5dd67bd7.mp3";